import * as React from 'react';

export type TNewbuildingPurchaseGiftPromoSource = 'sidebar';

export interface INewbuildingPurchaseGiftPromoContext {
  /** Точки входа акции можно показывать: тогл, конфиг, регион и группа эксперимента */
  isAvailable: boolean;
  openModal(source: TNewbuildingPurchaseGiftPromoSource): void;
  /**
   * Сайдбар рендерится дважды на странице (верхний и нижний блок):
   * показ язычка отправляется один раз на страницу.
   */
  trackSidebarShow(): void;
}

export const NewbuildingPurchaseGiftPromoContext = React.createContext<INewbuildingPurchaseGiftPromoContext>({
  isAvailable: false,
  openModal: () => {},
  trackSidebarShow: () => {},
});

export function useNewbuildingPurchaseGiftPromo(): INewbuildingPurchaseGiftPromoContext {
  return React.useContext(NewbuildingPurchaseGiftPromoContext);
}
